// extracted by mini-css-extract-plugin
export default {"pagination":"w8fLn0","rtl":"dlyZ2P","prev":"wXvqeR","next":"SSBRY9","paginationBreadcrumbs":"UG4Nec","breadcrumbsArrow":"FsDnlF","hidden":"NXXV9u"};